import { render, staticRenderFns } from "./lgScreenSetList.vue?vue&type=template&id=398e5c18"
import script from "./lgScreenSetList.vue?vue&type=script&lang=js"
export * from "./lgScreenSetList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports